module.exports = __webpack_public_path__ + "static/media/volume-down.0be67c3e.svg";